<template>
<!--    <div>-->
<!--        Chat with-->
<!--        <strong>{{ $_.get(activity, "refVisitor.fullname") }} </strong>-->
<!--        was closed by-->
<!--        <strong>{{ getActorName() }} </strong>-->
<!--    </div>-->
    <span v-html="$t('notification.chatClosed', { visitor: $_.get(activity, 'refVisitor.fullname'), agent: getActorName() })"></span>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatClosed",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getActorName() {
            if (this.activity.actor === "user") {
                return this.$_.get(this.activity, "actorUser.name");
            } else if (this.activity.actor === "visitor") {
                return this.$_.get(this.activity, "refVisitor.fullname");
            } else if (this.activity.actor === "chatbot") {
                return "Chatbot";
            } else if (this.activity.actor === "system") {
                return "System";
            }
        },
    },
});
</script>

<style scoped lang="scss"></style>
